module.exports = __webpack_public_path__ + "img/company_logo_12.9bc036bf.png";